import { RouterRootState } from "connected-react-router";
import React, { FC, ReactNode, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import ActivityFrame from "../../../components/activity-frame/activity-frame";
import Breadcrumb from "../../../components/breadcrumb/breadcrumb";
import LiftModal from "../../../components/lift-control/LiftModal";
import Tabs, { getTabsListFromLabels } from "../../../components/tabs/tabs";
import LiftTab from "../../../containers/lifts-tab";
import { useLocale } from "../../../contexts/localeContext";
import Restricted from "../../../contexts/PermissionProvider/RestrictedWrapper";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { useTabCount } from "../../../hooks/useCategoryTab";
import { Button } from "../../../components/button/Button";
import plusIcon from "../../../images/Plus.svg";
import { Category } from "../../../models/Category";
import { getListOfSiteIdsFromFilterWithKey } from "../../../utilities/tabUtils";

const getRouteNameFromPath = (path: string) => {
    const splitPath = path.split('/');
    return splitPath[splitPath.length - 1];
}

const Lifts: FC = () => {
    const { translate } = useLocale();
    const [selected, setSelected] = useState(0);
    const [busy, setBusy] = useState(false);
    const history = useHistory();
    const [categories, setCategories] = useState<Category[]>([
        {
            displayName: translate.byKey(TranslationKeys.lifts),
            heading: translate.byKey(TranslationKeys.lifts),
            value: "",
            id: 0,
            count: 0,
        }
    ]);
    const [tabContent, setTabContent] = useState<ReactNode[]>([]);
    const routeName = useSelector((state: RouterRootState) => getRouteNameFromPath(state.router.location.pathname));
    const [showModal, setShowModal] = useState(false);
    const [busyMessage, setBusyMessage] = useState<string>('');

    useEffect(() => {
        setCategories([
            {
                displayName: translate.byKey(TranslationKeys.lifts),
                heading: translate.byKey(TranslationKeys.lifts),
                value: "",
                id: 0,
                count:0,
            },
        ]);
    }, []);

    const onFilterChange = (filters: any) => {
        const siteIds = getListOfSiteIdsFromFilterWithKey(filters, "building.site.id");
        updateTabCount(siteIds);
    }

    useEffect(() => {
        if (categories.length > 0) {
            const newTabContent = [
                <LiftTab onFilterChange={onFilterChange}
                    setShowModal={setShowModal}
                    setBusy={setBusy}
                    categories={categories}
                    setCategories={setCategories}
                    setBusyMessage={setBusyMessage} />
            ];
            setTabContent(newTabContent);
        }
    }, [categories]);

    const {updateTabCount} = useTabCount({
            tableName:"Lift",
            pathToSite: "lift.building.site",
            categories,
            setCategories
        });

    const onSaveSuccess = () => {
        setCategories([{ ...categories[0], count: (categories[0]?.count ?? 1) + 1 }]);
    }

    return <ActivityFrame busy={busy} busyMessage={busyMessage} className="flex flex-grow overflow-y-hidden">
        <div id="container-tabs" className="pt-4 pl-4 pb-4 flex flex-col flex-grow ">
            <Breadcrumb
                path={[
                    {
                        value: "/access-control/hardware",
                        displayName: translate.byKey(TranslationKeys.hardware),
                    },
                    {
                        value: "/access-control/hardware/lifts",
                        displayName: translate.byKey(TranslationKeys.lifts),
                    },
                ]}
                onClick={(item) => history.push(item.value)} />
            <Tabs
                className="overflow-y-hidden"
                tabs={getTabsListFromLabels(categories)}
                onSelect={(i) => setSelected(i)}
                selected={selected}
                onAdd={() => { }}
                add={false}
                tabStyle={{}}>
                {tabContent[selected]}
                <div className="flex flex-row justify-end button-cluster">
                    <Restricted to={`add.${routeName}.element`}>
                        <Button variant="submit" shape="rounded" id="addLiftsButton" data-cy="addLiftsButton" onClick={() => setShowModal(true)}>
                            <img
                                src={plusIcon}
                                className="px-2 w-8 py-1"
                                alt="" />
                            <span className="mr-2">{translate.byKey(TranslationKeys.add)}</span>
                        </Button>
                    </Restricted>
                </div>
            </Tabs>
        </div>
        <LiftModal isOpen={showModal} setOpen={setShowModal} onSaveSuccess={onSaveSuccess} setBusy={setBusy} setBusyMessage={setBusyMessage} />
    </ActivityFrame>
};

export default Lifts;
